import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import ClientToken from '../../api/client-token';

// initial state
const state = {
    clientToken: null,
    clientTokenExp: null,
    clientId: '58d24544-7d73-41e4-886c-4d97f0eea476',
    clientSecret: '9e427304-6f0a-43ce-a488-9a554bc5b02d'
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    getClientToken({ commit, rootState }, { cb }) {
        let expired = true;
        let sessionToken = sessionStorage.getItem('clientToken');
        let sessionTokenExp = sessionStorage.getItem('clientTokenExp');
        
        if (sessionTokenExp) {
            let exp = moment(sessionTokenExp).format('YYYY-MM-DD HH:mm:ss');
            let now = moment.utc().format('YYYY-MM-DD HH:mm:ss');
            expired = moment(now).isAfter(exp);
        }
        
        if (!sessionToken || expired) {
            ClientToken.getClientToken((data) => {
                sessionStorage.setItem('clientToken', data.token);
                sessionStorage.setItem('clientTokenExp', data.expiresAtUtc);
                commit('setStateValue', { key: 'clientToken', value: data.token });
                commit('setStateValue', { key: 'clientTokenExp', value: data.expiresAtUtc });
                cb();
            }, { ClientId: state.clientId, ClientSecret: state.clientSecret });
        } else {
            commit('setStateValue', { key: 'clientToken', value: sessionToken });
            commit('setStateValue', { key: 'clientTokenExp', value: sessionTokenExp });

            cb();
        }
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
